import {useSubIssuesSummary} from '@github-ui/sub-issues/useSubIssuesSummary'

import type {SubIssuesSummaryParentNode} from './sub-issues-summary-query-types'
import styles from './SubIssuesSummary.module.css'
import type {SubIssueCompletionTokenProps} from './SubIssuesSummaryToken'
import {SubIssuesSummaryToken} from './SubIssuesSummaryToken'

type SubIssuesSummaryFragment = Pick<SubIssuesSummaryParentNode, 'url' | 'subIssuesSummary'>

interface SubIssueSummaryProps {
  issue: SubIssuesSummaryFragment
  onSummaryClick?: (event: React.MouseEvent, issueNode: {url: string} & unknown) => void
}

export function SubIssuesSummary({issue: data, onSummaryClick}: SubIssueSummaryProps) {
  const progress = useSubIssuesSummary(data)

  const anchorAttrs: Partial<SubIssueCompletionTokenProps> | undefined = onSummaryClick && {
    as: 'a',
    href: data.url,
    onClick: e => onSummaryClick(e, data),
  }

  return progress.total > 0 ? (
    <div className={styles.summaryContainer}>
      <SubIssuesSummaryToken {...anchorAttrs} progress={progress} />
    </div>
  ) : null
}
